import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchAssets } from "../../../actions/roblox/assetsActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../Assets/_partials/_PageHeader";
import List from "../Assets/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter from "../../../componets/Filter";
import { fetchCategories } from "../../../actions/roblox/categoriesActions";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "../../../store/roblox/assetsSlice";
import MenuCategories from "../../roblox/Categories/_partials/_MenuCategories";
import New from "../../roblox/Assets/New";
import NewCategory from "../../roblox/Categories/New";
import EditCategory from "../../roblox/Categories/Edit";
import CategoriesSettings from "../../roblox/Categories/Settings";
import robloxUrls from "../../../configs/roblox/robloxUrls";

const LIMIT = 42;

interface PropsInterface {
  target?: 'patterns' | 'accessories';
}

const NAV_ITEMS: {[index: number]: any} = {
  1: {
    id: 1,
    name: 'Patterns',
    url: robloxUrls.assetsPatternsPath()
  },
  2: {
    id: 2,
    name: 'Accessories',
    url: robloxUrls.assetsAccessoriesPath()
  }
};

const Assets = ({ target }: PropsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const categoryId      = queryParams.getInt(searchParams,'category_id');
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    const params: any = {};
    if (target) {
      params.target = target;
    }

    dispatch(fetchCategories(params));
  }, [target, dispatch]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (target) {
      params.target = target;
    }

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(fetchAssets(params));
  }, [categoryId, target, searchParams, currentPage, dispatch]);


  function onClickCreate() {
    const params: any = {};

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(setNewParams(params));
  }

  return (
    <PageLayout>
      <PageHeader
        title={'Assets'}
        navs={NAV_ITEMS}
        target={target}
        parent={{
          name: 'All',
          url: robloxUrls.assetsPath()
        }}
      />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Upload Assets
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            search
            orderBy={
              {
                defaultKey: 'id',
                defaultSort: 'desc',
                items: [{ name: 'Date', key: 'id' }]
              }
            }
          >
            <MenuCategories />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} />

        <New />

        <NewCategory />
        <EditCategory />
        <CategoriesSettings />
      </div>
    </PageLayout>
  );
}

export default Assets;
